import React from "react";
import { get } from "lodash";
import {
    Divider,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import InvoiceMonth from "./InvoiceMonth";
import utils from "../utils/index";
import "./Invoice.css";

const InvoicePeriod = (props) => {
    const { disableInputs, errors, handlePeriodChange, period } = props;

    return (
        <Accordion className="withTable">
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <div className="panelMegaLink">
                    <div className="invoiceHeaderText">
                        <div className="invoiceSubHeaderText">
                            <div>
                                <span className="tableTitleMonth">{period.periodId}</span>
                            </div>
                            <div>
                                <div className="invoiceSubHeaderText">
                                    <div className="tableTitleDate">
                                        {period.startDate} - {period.endDate}{" "}
                                        {period.preTermPeriod === true || period.postTermPeriod === true
                                            ? "(Outside Term)"
                                            : ""}
                                    </div>
                                </div>
                                <div>
                                    <span className="tableTitleDetails">
                                        {period.summary.totalMonths} month(s) / {period.summary.freeMonths} month(s)
                                        free / {period.summary.discountedMonths} month(s) discounted
                                    </span>
                                </div>
                            </div>
                        </div>
                        {period.periodId !== "S" && period.periodId !== "1" && period.periodId !== "E" && (
                            <div style={{ display: "flex", fontSize: "14px", fontWeight: "400", maxHeight: "55px" }}>
                                <div
                                    className="tableTitleDetails"
                                    style={{ paddingRight: "10px", paddingTop: "15px", fontSize: "13px" }}
                                >
                                    Escalation Rate
                                </div>
                                <div style={{ margin: "0px", minWidth: "80px", maxWidth: "80px" }}>
                                    <BSInput
                                        id="escalationRate"
                                        onClick={(event) => event.stopPropagation()}
                                        value={get(period, "escalationRate", null)}
                                        error={errors.escalationRate}
                                        onChange={(e) => {
                                            handlePeriodChange(period.periodNumber, e.target.id, e.target.value);
                                        }}
                                        placeholder="Enter escalation rate"
                                        disabled={disableInputs === true}
                                        extraFormControlStyles={{ margin: "0px", paddingTop: "4px" }}
                                        extraInputStyles={{ marginTop: "0px" }}
                                    />
                                </div>
                                <div>
                                    <BSSelect
                                        id="escalationRateType"
                                        combinedField="combinedFieldShiftLeft"
                                        error={errors.escalationRateType}
                                        value={get(period, "escalationRateType", null)}
                                        onChange={(e) => {
                                            handlePeriodChange(period.periodNumber, e.target.id, e.target.value);
                                        }}
                                        disabled={disableInputs === true}
                                        onClick={(event) => event.stopPropagation()}
                                        options={[
                                            {
                                                value: "%",
                                                label: "%",
                                            },
                                            {
                                                value: "$",
                                                label: "$",
                                            },
                                        ]}
                                        extraFormControlStyles={{ marginTop: "-18px", paddingTop: "0px" }}
                                    />
                                </div>
                            </div>
                        )}
                        <div>
                            <span className="tableTitleValue">
                                {utils.operations.toDollarAmount(period.summary.totalAmount)}
                            </span>
                        </div>
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails className="withTable">
                <Divider />
                <Table padding="none">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center">Month Range</TableCell>
                            <TableCell align="center">Free Rent</TableCell>
                            <TableCell align="center" numeric>
                                Discount %
                            </TableCell>
                            <TableCell align="center" numeric style={{ minWidth: "5em" }}>
                                Rate
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.keys(period["months"]).map((month, i) => (
                            <InvoiceMonth
                                {...props}
                                monthDetail={period["months"][month]}
                                periodNumber={period.periodNumber}
                                disableInputs={disableInputs || period.preTermPeriod || period.postTermPeriod}
                            />
                        ))}
                    </TableBody>
                </Table>
            </AccordionDetails>
        </Accordion>
    );
};

export default InvoicePeriod;
